const Endpoints = {
  //Auth
  login: "/admin/adminLogin",
  forgetPassword: "/admin/forgetPassword",
  verifyOTPUrl: "/admin/verify-otp",
  resetPasswordUrl: "/admin/resetPassword",

  //roles
  getRolesList: "/user/roleGetAll",
  deleteRole: "/user/roleDeleteById",
  getPermissions: "/user/permissionGet",
  addRole: "/user/roleAdd",
  getRole: "/user/roleGetById",
  updateRole: "/user/roleUpdate",
  getStaff: "/user/staffGetAll",
  getStaffById: "/user/staffGetById",
  updateStaffStatus: "/user/staffUpdate",
  deleteStaff: "/user/staffDeleteById",
  addStaff: "/user/staffAdd",
  getAllCustomer: "/admin/customers",
  getCustomerGroupList: "/admin/getGroup",

  getRolePermissionUrl: "/user/roleGetById",

  //customer
  getCustomerList: "/admin/customerList",
  getCustomer: "/admin/customers/getAggregatedData",
  addCustomer: "/admin/customerCreation",
  customerBlackilst: "/admin/customers/addToBlackList",
  updateCustomer: "/admin/customerUpdation",
  getCustomerOrderListUrl: "/order/listByUser",
  getCustomerCartListUrl: "/user/cart",
  getCustomerWishListUrl: "/user/wishlist",
  getCityBasedOnPincode: "/user/getCityBasedOnPincode",

  //customer group
  addCustomerGroup: "/admin/createGroup",
  updateCustomerGroup: "/admin/updateGroup",
  deleteCustomerGroup: "/admin/deleteGroups",
  deleteCustomer: "/admin/customers/deleteManyCustomer",
  searchCustomer: "/admin/customerSearch",
  deleteAddress: "/user/deleteAddress",

  // order management
  getOrderList: "/admin/orderlist",

  // http://doodlebluelive.com:2128/api/v1/order/getAllOutlets
  getOutletname:"/order/getAllOutlets",
  
  updateOrderStatus: "/admin/updateOderStatus",
  getSingleOrder: "/admin/getOrderdetailswithId",
  getOrderStatus: "/admin/getOrderStatus",
  bulkDeleteOrder: "/order",
  initiateRefund: "/order/razorpay/initiate-refund",

  //file upload
  fileUpload: "/upload/image/single",

  //appointment

  getAllAppointment: "/user/listAppointment",
  filterDetails: "/user/fetchDetails",
  getappointmentStatus: "/user/getStatuslist",
  updateappointment: "/user/updateAppointmentAdmin",
  deleteappointment: "/user/appointments",

  //service
  getAllService: "/location/service/listservice",
  getService: "/location/service/getservice",
  createService: "/location/service/add",
  updateService: "/location/service/updateservice",
  deleteService: "/location/service/deleteservice",
  //city
  getAllCity: "/location/listallcity",
  addCity: "/location/addcity",
  updateCity: "/location/updatecity",
  deleteCity: "/location/deletecity",
  //store
  getAllStore: "/location/locationlist",
  getStore: "/location/locationget",
  createStore: "/location/locationadd",
  updateStore: "/location/locationupdate",
  deleteStore: "/location/locationdelete",

  //testimonials
  creatTestimonials: "/user/addReview",
  testimonialsmangament: "/user/listReview",
  deletetestimonals: "/user/deleteReview",
  editTestimonals: "/user/updateReview",
  updatePublish: "/user/publishReview",

  // StaticPageManagement
  staticpageManagement: "/user/listStaticPage",
  deletestaticManagement: "/user/deleteStaticPage",
  createstaticManagement: "/user/addStaticPage",
  editstaticManagement: "/user/updateStaticPage",
  unPublishStaticPage: "/user/unpublishStaticPage",

  // Catlog Management Product tab
  getProductsList: "/user/getProducts",
  exportProductsList: "/user/productsExport",
  addNewProductDetails: "/user/createProduct",
  deleteProductsUrl: "/user/removeProducts",
  updateProductDetailsUrl: "/user/updateProduct",
  updateProductStatusDetailsUrl: "/user/updateStatus",
  findFilterUrl: "/user/filter/getfilter",
  getUserZoneUrl: "/user/zone/readZone",

  //Static
  brand: "/static/brand",

  // Catlog Management Tax slab tab
  getTaxSlabTableList: "/user/tax/listtax",
  addNewTaxSlab: "/user/tax/addtax",
  editTaxSlab: "/user/tax/updatetax",
  deleteTaxSlab: "/user/tax/deletetax",
  getTaxSlabDetails: "/user/tax/gettax",
  downloadCatlogFileUrl: "/upload/catlog/download-template",
  bulkUploadProductUrl: "/upload/catlog",

  // Catlog management Category tab
  getCategoryListMain: "/category/categoryTree",
  addEditCategoryUrl: "/category/category",
  getProductDetailsUr: "/user/getProductById",

  // Catlog management Filter tab
  getFilterListUrl: "/user/filter/listfilter",
  addNewFilterUrl: "/user/filter/addfilter",
  updateFilterUrl: "/user/filter/updatefilter",
  deleteFilter: "/user/filter/deletefilter",
  bulkDeleteFilterUrl: "/user/filter/deleteManyFilter",
  getIndividualFilterUrl: "/user/filter/getfilter",

  //Master list
  getTaxConfigSlab: "/user/taxConfigSlabGet",
  getBrandListUrl: "/static/brand",
  getComboProductsListUrl: "/user/products",

  //coupon managemnet
  addCoupon: "/user/couponAdd",
  getAllCoupons: "/user/couponGet",
  deleteCoupon: "/user/couponDelete",
  getSingleCoupon: "/user/couponGet",
  editCoupon: "/user/couponUpdate",

  //cart management
  getAllCart: "/user/carts",
  getCartById: "/user/cart",

  //banner management
  createBanner: "/user/createBanner",
  getBannerList: "/user/readBanner",
  updateBanner: "/user/updateBanner",
  getBannerById: "/user/getBanner",
  deleteBanner: "/user/deleteBanner",

  //Setting
  setting: "/user/settings",

  //BlogCategory

  createblogCategory: "/user/createBlogCategory",
  editblogCategory: "/user/updateBlogCategory",
  deleteblogCategory: "/user/deleteBlogCategory",
  getblogCategory: "/user/readBlogCategory",

  //BlogPost

  getblogPost: "/user/readBlog",
  deleteblogPost: "/user/deleteBlog",
  createblogPost: "/user/createBlog",
  createUploadpost: "/upload/image/single",
  EditBlogPost: "/user/updateBlog",
  updateUnpublish: "/user/unpublishBlog",

  // Shipping
  postshippingPost: "/user/zone/addZone",
  getshippingPost: "/user/zone/readZone",
  putShipping: "/user/zone/updateZone",
  deleteShipping: "/user/zone/deleteZone",
  shippingTemplateDownload: "/upload/zone/download-template",
  uploadShippingZone: "/upload/zone",

  // Reports
  getSalesStatistics: "/report/salesStatistics",
  customerWidget: "/report/CustomerWidget",
  appointmentWidget: "/report/AppointmentWidget",
  orderSourceStatistics: "/report/orderSourceStatistics",
  productStatistics: "/report/productStatistics",
  brandWiseOrderList: "/report/brandWiseOrderList",
  categoryWiseOrderList: "/report/categoryWiseOrderList",

  // Notification
  getAllNotification: "/communicate/notificationList",
  markAsRead: "/communicate/updateNotification",
};

const APIMethods = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export default {
  Endpoints,
  APIMethods,
};
